import React from 'react';
import PropTypes from 'prop-types';

const ProductScarcity = ({ scarcityValue }) => {
  const peopleOrPerson = () => {
    return scarcityValue === 1 ? 'person' : 'people';
  };

  return (
    <div className="ch-mb--2">
      <span className="ch-rounded--sm ch-fs--1 ch-pa--1 ch-text--bold ch-color--ac-red scarcity-alert">
        {scarcityValue} {peopleOrPerson()} shortlisted this car
      </span>
    </div>
  );
};
export default ProductScarcity;

ProductScarcity.propTypes = {
  scarcityValue: PropTypes.number,
};
